import { StockProvider, StockList, AbstractStockProvider } from "../../providers/stock";
import { StockService, AbstractStockService, AbstractStockServiceSetter  } from '../../services/stock';
import { createContext, useContext } from 'react';
import {useUpdateCustomerAccessToken} from "../../hooks/useUpdateCustomerAccessToken/useUpdateCustomerAccessToken";

const StockContextBuilder = (provider: AbstractStockProvider) => {
  return createContext<AbstractStockService>(new StockService(provider, {
    updateCustomer: (accessToken: string) => {}
  }));
}

export const StockServiceContext = StockContextBuilder(new StockProvider());
const provider = new StockProvider();

export const StockServiceContextProvider = ({children}: {children: React.ReactNode}) => {
  const updateCustomerAccessToken = useUpdateCustomerAccessToken();
  const setter: AbstractStockServiceSetter = {
    updateCustomer: updateCustomerAccessToken
  }

  return (
    <StockServiceContext.Provider value={new StockService(provider, setter)}>
      {children}
    </StockServiceContext.Provider>
  )
}